import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { SOURCE_SURFACES_OPTIONS } from '@/constants/enums';

export default function SectionSurfaces({ data, onChange }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);

  return (
    <section className="space-y-6">
      <h3 className="text-lg font-semibold text-slate-900">Surfaces</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label="Source des surfaces"
          name="surfaces.source"
          value={val('surfaces.source')}
          options={SOURCE_SURFACES_OPTIONS}
          onChange={handleChange('surfaces.source')}
        />
        <Input
          label="Surface habitable (m²)"
          name="surfaces.habitable_m2"
          type="number"
          value={val('surfaces.habitable_m2')}
          onChange={handleChange('surfaces.habitable_m2')}
        />
        <Input
          label="Surface annexe (m²)"
          name="surfaces.annexe_m2"
          type="number"
          value={val('surfaces.annexe_m2')}
          onChange={handleChange('surfaces.annexe_m2')}
        />
        <Input
          label="Surface annexe habitation (m²)"
          name="surfaces.annexe_habitation_m2"
          type="number"
          value={val('surfaces.annexe_habitation_m2')}
          onChange={handleChange('surfaces.annexe_habitation_m2')}
        />
        <Input
          label="Vérandas (m²)"
          name="surfaces.verandas_m2"
          type="number"
          value={val('surfaces.verandas_m2')}
          onChange={handleChange('surfaces.verandas_m2')}
        />
        <Input
          label="Garages / Caves (m²)"
          name="surfaces.garages_caves_m2"
          type="number"
          value={val('surfaces.garages_caves_m2')}
          onChange={handleChange('surfaces.garages_caves_m2')}
        />
        <Input
          label="Terrasses / Balcons (m²)"
          name="surfaces.terrasses_balcons_m2"
          type="number"
          value={val('surfaces.terrasses_balcons_m2')}
          onChange={handleChange('surfaces.terrasses_balcons_m2')}
        />
        <div className="md:col-span-3 text-sm font-medium text-slate-700">
          Surface totale : {(
            (parseFloat(val('surfaces.habitable_m2')) || 0) +
            (parseFloat(val('surfaces.annexe_m2')) || 0) +
            (parseFloat(val('surfaces.annexe_habitation_m2')) || 0) +
            (parseFloat(val('surfaces.verandas_m2')) || 0) +
            (parseFloat(val('surfaces.garages_caves_m2')) || 0) +
            (parseFloat(val('surfaces.terrasses_balcons_m2')) || 0)
          ).toFixed(2)} m²
        </div>
      </div>
    </section>
  );
}
